import React from 'react';
import LandingPageCMS from '../components/LandingPage';

const LandingPageManagement = () => {
  return (
    <>
      <LandingPageCMS />
    </>
  );
};

export default LandingPageManagement;
